/**
 * Redux slice for maintaining status messages that can be inferred from various API responses.
 */

import { createSlice } from "@reduxjs/toolkit"

interface StatusMessageState {
	openSurveyTasks: boolean
}

const initialState: StatusMessageState = {
	openSurveyTasks: false,
}

export const statusSlice = createSlice({
	name: "statusMessage",
	initialState,
	reducers: {},
})
